export default [
  {
    key: 'search',
    label: 'field.title',
    type: 'text',
    md: 12,
    lg: 12
  },
  // {
  //   key: 'isEnabledServiceSystem',
  //   label: 'field.serviceSystem',
  //   type: 'radio',
  //   options: [
  //     { text: 'field.enabled', value: true },
  //     { text: 'field.disabled', value: false },
  //   ],
  //   md: 'auto',
  //   lg: 'auto',
  // },
];
